export const getFileName = (folder, name, fallback = "BIMSearch report") =>
  folder ? `${folder} - ${name}` : fallback;

export default getFileName;
